import React, { useEffect, useRef } from 'react';
import { packedMap, reject } from '../../../../utils/CoreExtensions/ObjectExtensions';
import { renderToString } from 'react-dom/server';
import ChrInfoPopoverTemplate from './ChrInfoPopoverTemplate';

const ChrInfoPopover = (props) => {
  const popOverRef = useRef();
  let template = props.template;
  if(!template && props.useTemplate) template = renderToString(<ChrInfoPopoverTemplate {...(props.templateOptions || {})}/>);

  // TODO_ADMIN_DASHBOARD_PROGRAM_COMMUNICATION: The `container` option is provided to this component from various sources to ensure text color consistency with the new admin dashboard, which had different colors. We manually overrode the popover body color for popovers within this container. However, the app's color scheme is now streamlined, so passing the container for this purpose is no longer necessary. Once this is discontinued, the popover text will revert to the default popover text color. To modify this default color, we can pass classes, as demonstrated in `ChrAlert`.

  useEffect(() => {
    // Using jQuery here because
    // 1. Using bootstrap react's popover component is ruled out due to it's outdated version compared to our react version
    // 2. Popover support is provided by bootstrap only with jQuery
    // We can use bootstrap-react's Popover component once we upgdrade bootstrap-react
    if (!props.renderedAsString) {
      const popoverOptions = {...props};
      const element = jQuery(popOverRef.current);
      if(template) popoverOptions.template = template;
      element.popover('dispose'); // Dispose any existing popover to avoid duplicates
      element.popover(popoverOptions);
    }
    return () => {
      jQuery('.popover').remove();
    };
  });
  const { iconClass = "fa-circle-info", additionalIconClass } = props;
  const content = props.children || (
    <i className={ `fa-solid ${iconClass} ${additionalIconClass}` } />
  );

  const getDataAttrs = () => {
    // This component is rendered via renderToString method in some places. In such cases, useEffect won't run. To handle such cases, props are set as data attributes and the popover is initialized separately using cjs-manual-react-popover class
    if (!props.renderedAsString)
      return {};
    let shortlistedProps = reject(props, "children", "renderedAsString", "iconClass", "additionalIconClass", "useTemplate", "templateOptions", "wrapperClassName");
    if(template) shortlistedProps.template = template;
    shortlistedProps.toggle = "popover";
    let newProps = packedMap(shortlistedProps, ([key, value]) => {
      return [`data-${key}`, value];
    });
    newProps.className = "cjs-manual-react-popover";
    return newProps;
  };

  const dataAttrs = getDataAttrs();
  const wrapperClassName = [props.wrapperClassName, dataAttrs.className].filter(Boolean).join(" ") || undefined;

  return (
    <div tabIndex="0" ref={ popOverRef } { ...dataAttrs } className={ wrapperClassName } >
      { content }
    </div>
  );
};

export default ChrInfoPopover;
